import { render, staticRenderFns } from "./customerListOrder.vue?vue&type=template&id=64e2b7fe&scoped=true"
import script from "./customerListOrder.vue?vue&type=script&lang=js"
export * from "./customerListOrder.vue?vue&type=script&lang=js"
import style0 from "./customerListOrder.vue?vue&type=style&index=0&id=64e2b7fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2b7fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e2b7fe')) {
      api.createRecord('64e2b7fe', component.options)
    } else {
      api.reload('64e2b7fe', component.options)
    }
    module.hot.accept("./customerListOrder.vue?vue&type=template&id=64e2b7fe&scoped=true", function () {
      api.rerender('64e2b7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customerListOrder/customerListOrder.vue"
export default component.exports